import mixpanel from "mixpanel-browser";

export function trackEvent(eventName) {
    try {
        window?.gtag("event", eventName, {
            event_category: "frame",
            event_label: eventName
        });
    } catch (e) {
        console.log(e);
    }
    try {
        window?.fbq("track", eventName, {
            content_name: "frame"
        });
    } catch (e) {
        console.log(e);
    }
    try {
        window.dataLayer = window?.dataLayer || [];
        window.dataLayer.push({
            event: eventName,
            eventCategory: "frame",
            eventLabel: eventName
        });
        console.log("dataLayer", window.dataLayer);
    } catch (e) {
        console.log(e);
    }
}

export function identifyUser(phone) {
    try {
        mixpanel.identify(phone);

        mixpanel.people.set({
            $phone: phone
        });
    } catch (e) {
        console.log(e);
    }
}

export function trackMixEvent(eventName, subEvent, bookId = "", message = "", clientId = "") {
    try {
        mixpanel.track(eventName, {
            subEvent: subEvent,
            bookId: bookId,
            message: message,
            clientId: clientId
        });
    } catch (e) {
        console.log(e);
    }
}
